import React, { ReactNode } from 'react'
import { LinkBox } from 'front-end/src/components'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'

interface FilterCheckboxProps {
  toggleFilter: () => void
  isChecked: boolean
  title: ReactNode
}

export const FilterCheckbox = ({
  toggleFilter,
  isChecked,
  title
}: FilterCheckboxProps) => {
  const { theme } = useLooopTheme()

  return (
    <LinkBox
      display="flex"
      alignItems="center"
      role="checkbox"
      onClick={toggleFilter}
      _before={{
        content: '""',
        h: '10px',
        w: '10px',
        display: 'block',
        border: `1px solid ${theme.colors.grey[500]}`,
        mr: '12px',
        borderRadius: '5px',
        bgColor: isChecked ? theme.colors.grey[500] : 'transparent'
      }}
      fontSize="12px"
      lineHeight="20px"
      color={theme.colors.grey[500]}
      cursor="pointer"
    >
      {title}
    </LinkBox>
  )
}
